/** Missing or true → pickers visible; only explicit `false` hides them. */
export function resolveLocaleEnabled(value: unknown): boolean {
  return value !== false;
}

export function isLocalePickerEnabledFromCompany(
  company?: {locale_enabled?: boolean} | null,
): boolean {
  return resolveLocaleEnabled(company?.locale_enabled);
}
